export const SetupRequirements = () => {
	return (
		<div className="space-y-2">
			<h5 className="text-base font-bold">連携開始に必要な準備</h5>
			<div className="rounded-r-md border-l-4 border-l-error-600 bg-error-200 p-4">
				<div className="space-y-2">
					<p className="text-sm font-medium">
						<strong>重要：</strong>Google無料予約リンクの連携を開始するには、事前に
						<strong>Googleビジネスプロフィール</strong>への登録・認証が必要です。
					</p>
					<div className="text-gray-700 text-sm">
						<p>必要な手順：</p>
						<ol className="list-inside list-decimal space-y-1 pl-2">
							<li>Googleビジネスプロフィールに宿泊施設を登録</li>
							<li>施設の所有者として認証を完了</li>
							<li>施設情報を充実させる（写真、営業時間等）</li>
							<li>CHILLNNでGoogle無料予約リンクの設定を開始</li>
						</ol>
					</div>
					<p className="text-gray-600 text-xs">
						※Googleビジネスプロフィールの登録がお済みでない場合は、
						<a
							href="https://business.google.com/"
							target="_blank"
							rel="noopener noreferrer"
							className="text-link-400 underline-offset-4 hover:underline"
						>
							こちら
						</a>
						から登録してください。
					</p>
				</div>
			</div>
		</div>
	);
};
